import {useState} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {createOCAPIFetch} from '../utills/customFetchOCAPI'

const usePasswordReset = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const getPasswordResetToken = async (email) => {
        setIsLoading(true)
        setError(null)

        try {
            const {app: appConfig} = getConfig()
            const customFetch = createOCAPIFetch(appConfig, 'customers/password_reset')

            const args = [
                {
                    headers: {
                        'x-dw-client-id': appConfig.ocapiAPI.contentAPIKey
                    }
                }
            ]

            const body = {
                identification: email,
                type: 'login'
            }

            if (typeof window !== 'undefined') {
                localStorage.setItem('passwordResetEmail', email)
            }

            const response = await customFetch('POST', args, body)
            return response
        } catch (err) {
            setError(err)
            throw err
        } finally {
            setIsLoading(false)
        }
    }

    return {
        getPasswordResetToken,
        isLoading,
        error
    }
}

export {usePasswordReset}
